import { render, staticRenderFns } from "./StackBar.vue?vue&type=template&id=07bf40a8"
import script from "./StackBar.vue?vue&type=script&lang=js"
export * from "./StackBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07bf40a8')) {
      api.createRecord('07bf40a8', component.options)
    } else {
      api.reload('07bf40a8', component.options)
    }
    module.hot.accept("./StackBar.vue?vue&type=template&id=07bf40a8", function () {
      api.rerender('07bf40a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chart/StackBar.vue"
export default component.exports